/**
 * VehicleActionCreator - for Supplier ledger
 */

import * as constants from "./../constants";
import { getVehicleNumberValues, getAvatarStringFromName, getVehicleNumberValuesDWeb } from "./utils/utils"
import * as logger from './../../logger';


export const getVehicleLedgerData = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/fetchvehicle-v3",
        data,
        success: (response) => populateVehicleLedgerData(response, data && data.merge ? data.merge : false),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

const populateVehicleLedgerData = (response, merge) => {
    var payloadData = { allTruckCount: 0, myTruckCount: 0, hiredTruckCount: 0, vehicleLedgerData: [] }
    if (response.status && response.status.code && response.status.code == 200) {
        var vehicleResponse = response.response
        payloadData.myTruckCount = vehicleResponse.self_vehicle_count
        payloadData.hiredTruckCount = vehicleResponse.hired_vehicle_count
        payloadData.allTruckCount = vehicleResponse.self_vehicle_count + vehicleResponse.hired_vehicle_count

        payloadData.vehicleTypes = vehicleResponse.vehicleTypes;
        payloadData.merge = merge;
        payloadData.vehiclesMaxPage = vehicleResponse.maxPage
        var vehicles = vehicleResponse.vehicles
        if (vehicles && vehicles.length > 0) {
            for (var i = 0; i < vehicles.length; i++) {
                var vehicleNumArray = getVehicleNumberValues(vehicles[i].vehicleNumber)
                var vehicleNumArrayValue = getVehicleNumberValuesDWeb(vehicles[i].vehicleNumber);
                var vehicleDisplayStatus = vehicles[i].status ? constants.VEHICLE_STATUS[vehicles[i].status] : ''
                payloadData.vehicleLedgerData.push({
                    vehicleNumberPrefix: vehicleNumArray[0],
                    vehicleNumberSuffix: vehicleNumArray[1],
                    vehicleNumArrayDweb: vehicleNumArrayValue,
                    vehicleType: vehicles[i].vehicleType,
                    status: vehicleDisplayStatus,
                    startLocation: vehicles[i].vehicleStartLocation,
                    destinationLocation: vehicles[i].vehicleDestinationLocation,
                    driverName: vehicles[i].driverName,
                    driverNumber: vehicles[i].driverNumber,
                    verified: vehicles[i].vehicle_verification_status,
                    lastLocation: vehicles[i].lastLocation,
                    vehicleNumber: vehicles[i].vehicleNumber,
                    ownershipType: vehicles[i].ownershipType,
                    id: vehicles[i].id,
                    tripId: vehicles[i].tripId ? vehicles[i].tripId : "",
                    vendor: vehicles[i].vendor,
                    vehicleVerificationStatus: vehicles[i].vehicle_verification_status,
                    vehicleBodyType: vehicles[i].vehicleBodyType,
                    driverId: vehicles[i].driverId ? vehicles[i].driverId : null,
                    driver: vehicles[i].driverId ? { id: vehicles[i].driverId, name: vehicles[i].driverName, contactNumber: vehicles[i].driverNumber } : null
                });
            }

        }
        logger.log("VehicleActionCreator", payloadData);
    } else {
        console.error("Error while fetching vehicle ledger data : " + response.status.code + " : " + response.status.message)
    }
    return { type: constants.GET_VEHICLE_LEDGER_DATA, payload: payloadData };
}

/**
 * Function to toggle create vehicle dialog open
 */
export const updateCreateVehicleOpen = () => { return { type: constants.UPDATE_CREATE_VEHICLE_OPEN, payload: null }; }

/**
 * Function to fetch all vendor data
 */
export const getAllVendors = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vendor/all",
        data,
        success: (response) => populateAllVendorData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

/**
* Function to fetch all Driver data
*/
export const getAllDrivers = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/drivers",
        data,
        success: (response) => populateAllDriverData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

const populateAllVendorData = (response) => {
    var payload = [];
    if (response.status && response.status.code && response.status.code == 200) {
        payload = response.response;
    }
    return { type: constants.GET_ALL_VENDOR_DATA, payload: payload };
}

const populateAllDriverData = (response) => {
    var driverDataResponse = [];
    if (response.status && response.status.code && response.status.code == 200) {
        if (response.response) {
            driverDataResponse = response.response

            if (driverDataResponse.length > 0)
                for (var i = 0; i < driverDataResponse.length; i++) {
                    driverDataResponse[i].avatarString = getAvatarStringFromName(driverDataResponse[i].name);
                }
        } else {
            logger.log("Error while fetching driver ledger data : " + response.status.code + " : " + response.status.message)
        }
    } else {
        logger.log("vehicle action creator", "Error while fetching drivers");
    }
    return { type: constants.GET_ALL_DRIVER_DATA, payload: driverDataResponse };
}

/**
 * Function to fetch all vehicle Type Configs
 */
export const getAllVehicleTypeConfigs = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicle/truck_types",
        data,
        success: (response) => populateAllVehicleTypesConfigs(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

const populateAllVehicleTypesConfigs = (response) => {
    var payload = [];
    if (response.status && response.status.code && response.status.code == 200) {
        payload = response.response;
    }
    return { type: constants.VEHICLE_TYPES_CONFIG, payload: payload };
}
/**
 * Function to add new vendor
 */
export const addNewVendor = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vendor",
        data,
        success: (response) => processNewVendor(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

export const editVendor = (id, data, onSuccess, onError) => ({

    type: constants.API,
    payload: {
        method: "PUT",
        url: `/vendor/${id}`,
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }

});

export const singleVendorDetails = (id, onSuccess, onError) => ({

    type: constants.API,
    payload: {
        method: "GET",
        url: `/vendor/${id}`,
        success: (response) => processSingleVendorDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }

});

export const deleteVendor = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: `/vendor/${id}`,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const deleteShop = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: `/khata/shop//${id}`,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

const processSingleVendorDetails = (response) => {
    let payloadData = response.response;

    return { type: constants.GET_SINGLE_VENDOR_DETAILS, payload: payloadData }
}

const processNewVendor = (response) => {
    var payload = [];
    if (response.status && response.status.code && response.status.code == 200) {
        payload = response.response;
    }
    return { type: constants.UPDATE_NEW_VENDOR_DATA, payload: payload };
}
/**
 * Function to add new vendor
 */
export const addNewDriver = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/driver",
        data,
        success: (response) => processNewDriver(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

const processNewDriver = (response) => {
    var payload = [];
    if (response.status && response.status.code && response.status.code == 200) {
        payload = response.response;
    }
    return { type: constants.UPDATE_NEW_DRIVER_DATA, payload: payload };
}
const returnInfo = (data) => {
    return { type: constants.RETURN_INFO, payload: data };
};

/**
 * Function to add new vehicle
 */
export const addNewVehicle = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicles-v2",
        data,
        success: (response) => processNewVehicle(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});
export const addNewVehicleV3 = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicles-v3",
        data,
        success: (response) => processNewVehicle(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    },
});

const processNewVehicle = (response) => {
    let payloadData = response.response;
    if (response.status && response.status.code && response.status.code == 200) {
        var vehicleNumArray = getVehicleNumberValues(payloadData.vehicleNumber);
        payloadData.vehicleNumberPrefix = vehicleNumArray[0];
        payloadData.vehicleNumberSuffix = vehicleNumArray[1];
        logger.log("VehicleActionCreator", "--> Vehicle Creation Success");
    }
    return { type: constants.ADD_VEHICLE, payload: payloadData };
};
/**
 *  Function to update vehicle
 */
export const updateVehicle = (vehicleId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: "/vehicles-v2/" + vehicleId,
        data,
        success: (response) => processUpdatedVehicle(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
/**
 *  Function to update vehicle
 */
export const updateVehicle3 = (vehicleId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: "/vehicles-v3/" + vehicleId,
        data,
        success: (response) => processUpdatedVehicle(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
// Fetch single truck data.
export const getSingleTruck = (vehicleId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicles-v3/" + vehicleId,
        success: (response) => processGetTruck(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
const processGetTruck = (response) => {
    let payloadData = {
        id: null,
        fleetOwnerId: null,
        ownershipType: "",
        vehicleNumber: "",
        vehicleType: "",
        vehicleBodyType: "",
        vendorId: null,
        vendor: {},
        driver: {},
        driverName: "",
        driverContactNumber: "",
        vehicleTypeDetails: {},
    }
    if (response.status && response.status.code && response.status.code == 200) {
        let data = response.response;
        if (data && data.driverId) {
            data.driver = {
                name: data.driverName ? data.driverName : "",
                id: data.driverId,
                contactNumber: data.driverNumber ? data.driverNumber : ""
            }
            data.driverContactNumber = data.driverNumber ? data.driverNumber : ""
        }
        payloadData = data;
    }
    return { type: constants.UPDATE_CURRENT_VEHICLE_DATA, payload: payloadData }
}

// Fetch single truck data.
export const singleTruck = (vehicleId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicles-v3/" + vehicleId,
        success: (response) => processSingleTruck(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

//Get pnl widget data.
export const PandL = (data, defaultDateFilterValue, onSuccess, onError,empty) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/pnl_report",
        data,
        success: (response) => processTripPandL(response, defaultDateFilterValue,empty),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

//Get vehicle monthly pnl widget data.
export const vehicleMonthlyPnlReport = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/pnl_report_monthly",
        data,
        success: (response) => processVehicleMonthlyProfitLoss(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const vehicleMonthlyPnlReportPDF = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicle/" + data.vehicleId + "/monthly_pnl_report_pdf/" + data.month,
        success: (response) => processVehicleMonthlyProfitLossPDF(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const vehicleTripPNLMonthlyList = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicle/pnl_months/" + data.vehicleId,
        success: (response) => processVehicleTripPNLMonths(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const vehicleTripPNLMonthlyPDF = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicle/" + data.vehicleId + "/trip_book/pdf/" + data.month,
        success: (response) => processVehicleTripPNLMonthlyPDF(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const getVehicleDocumentPDF = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/" + data.vehicleId + "/document_book_pdf",
        data,
        success: (response) => processVehicleDocumentPDF(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

//Get Truck log data.
export const Expenses = (data, defaultTripBookFilterValue, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/expense_log",
        data,
        success: (response) => processTripExpenses(response, defaultTripBookFilterValue, data && data.merge ? data.merge : false),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const marketVehicleExpenses = (data, defaultTripBookFilterValue, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/market-vehicle/expense_log",
        data,
        success: (response) => processTripExpenses(response, defaultTripBookFilterValue, data && data.merge ? data.merge : false),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const VehicleExpenseType = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicle/maintenance_book/expense_types",
        success: (response) => processVehicleExpenses(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const DriverExpenseType = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicle/other_expenses_book/expense_types",
        success: (response) => processDriverExpenses(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const AddExpenseTypeDriver = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/other_expenses_book/custom_expense_type",
        data,
        success: (response) => processAddExpenseType(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const AddExpenseTypeMaintenance = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/maintenance_book/custom_expense_type",
        data,
        success: (response) => processAddExpenseType(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const FetchExpenseDetails = (expenseId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vendor_expense/" + expenseId,
        success: (response) => processFetchExpenseDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const UpdateExpenseDetails = (expenseId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: "/vendor_expense/" + expenseId,
        data,
        success: (response) => processUpdateExpenseDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const DeletePhotoAttachments = (expenseId, attachmentId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: "/vendor_expense/" + expenseId + "/attachment/" + attachmentId,
        success: (response) => processDeletePhotoDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }

});

export const DeleteExpense = (expenseId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: "/vendor_expense/" + expenseId,
        success: (response) => processDeleteExpense(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const FetchDocumentDetails = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/document/fetch",
        data,
        success: (response) => processFetchExpenseDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const DeleteDocument = (documentId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: "/vehicle/document/" + documentId,
        success: (response) => processDeleteExpense(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const GetVehicleDocumentConfig = (onSuccess, onError, data = { filteredKeys: ["vehicle_document_reminder_config"] }) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/configs/filtered",
        data,
        success: (response) => processDocumentConfig(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const deletePhotoDocuments = (documentId, attachId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: "/vehicle/document/" + documentId + "/document_img/" + attachId,
        success: (response) => processDeletePhotoDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const emiDate = (vehicleId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicle/" + vehicleId + "/pending_emi_dates",
        success: (response) => processEmiSelectDate(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const fetchTripBook = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/tripbook",
        data,
        success: (response) => processFetchTruckBook(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const fetchTripBookV2 = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/v2/trip/filters/apply",
        data,
        success: (response) => processFetchTruckBookV2(response, data && data.merge ? data.merge : false),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const fetchTripBookV3 = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/journeys",
        data,
        success: (response) => processFetchTruckBookV2(response,data && data.merge ? data.merge : false),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const fetchDocumentsBook = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/document/fetch/all",
        data,
        success: (response) => processFetchDocumentsBook(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const fetchFuelBook = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/fuel_book",
        data,
        success: (response) => processFetchTruckBook(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const fetchMaintenanceBook = (data, defaultExpenseTypeFilter, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/maintenance_book/all",
        data,
        success: (response) => processFetchTruckBook(response, defaultExpenseTypeFilter),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const fetchOtherExpensesBook = (data, defaultExpenseTypeFilter, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/other_expenses_book",
        data,
        success: (response) => processFetchTruckBook(response, defaultExpenseTypeFilter),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const fetchEmiBook = (vehicleId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicle/" + vehicleId + "/emi_book",
        success: (response) => processFetchTruckBook(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }

});

export const fetchDueOn = (vehicleId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/vehicle/" + vehicleId + "/pending_emi_dates",
        success: (response) => processFetchTruckBook(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const fetchCalenderDates = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/calendar_dates",
        success: (response) => processCalenderDates(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const UpdateVehicleEmi = (vehicleId, emiId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: "/vehicle/" + vehicleId + "/emi/" + emiId,
        data,
        success: (response) => processUpdateExpenseDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const deleteVehicleEmi = (vehicleId, emiId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: "/vehicle/" + vehicleId + "/emi/" + emiId,
        success: (response) => processDeleteExpense(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const addVehicleEmi = (vehicleId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/" + vehicleId + "/emi",
        data,
        success: (response) => processAddEmi(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

// export const fetchDocumentBook = (data, onSuccess, onError) => ({
//     type: constants.API,
//     payload: {
//         method: "POST",
//         url: "/vehicle/document/fetch/all",
//         data,
//         success: (response) => processFetchTruckBook(response),
//         postProcessSuccess: onSuccess,
//         postProcessError: onError,
//     }
// });

export const fetchMaintenanceUpcoming = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/maintenance_book/upcoming",
        data,
        success: (response) => processFetchMaintenanceUpcoming(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const addDocument = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/vehicle/document",
        data,
        success: (response) => processAddDocument(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const editDocument = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: "/vehicle/document",
        data,
        success: (response) => processAddDocument(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const getVehicleMaintenanceConfig = (onSuccess, onError, data = { filteredKeys: ["vehicle_maintenance_expense_reminder_config"] }) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/configs/filtered",
        data,
        success: (response) => processVehicleMaintenanceConfig(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

const processVehicleMaintenanceConfig = (data) => {
    let response = data && data.response && data.response.vehicle_maintenance_expense_reminder_config ? data.response.vehicle_maintenance_expense_reminder_config : {};
    return { type: constants.GET_VEHICLE_CONFIG, payloadData: response }
};

const processAddDocument = (response) => {
    logger.log("VehicleActionCreator", "Incoming response from add new document", response);
    return { type: null, payload: null };
}


// export const maintenanceMarkPaid = (onSuccess, onError) => ({
//     type: constants.API,
//     payload: {
//         method: "GET",
//         url: "/vehicle/maintenance_book/expense_types",
//         success: (response) => processAddMarkPaid(response),
//         postProcessSuccess: onSuccess,
//         postProcessError: onError,
//     }
// });

// const processFetchFuelBook = (response) => {
//     let payloadData = response.response;
//     return { type: constants.GET_TRUCK_BOOK, payload: payloadData };
// }

// const processAddMarkPaid = (response) => {
//     logger.log("VehicleActionCreator", "Incoming response from add new vehicle emi", response);
//     return { type: null, payload: null };
// }

const processFetchMaintenanceUpcoming = (response) => {
    logger.log("VehicleActionCreator", "Get maintenance upcoming successfull", response);
    let payloadData = response.response;
    return { type: constants.GET_MAINTENANCE_UPCOMING, payload: payloadData };
}

const processFetchDocumentsBook = (response) => {
    let payloadData = response.response;
    if (response.status && response.status.code && response.status.code == 200) {
        var vehicleNumArray = getVehicleNumberValues(payloadData.vehicleNumber);
        var vehicleNumArrayDweb = getVehicleNumberValuesDWeb(payloadData.vehicleNumber);
        payloadData.vehicleNumberPrefix = vehicleNumArray[0];
        payloadData.vehicleNumberSuffix = vehicleNumArray[1];
        payloadData.vehicleNumberDweb = vehicleNumArrayDweb;
    }
    return { type: constants.GET_VEHICLE_DOCUMENTS_BOOK, payload: payloadData };
}

// const processFetchTruckBook = (response) => {
//     let payloadData = response.response;
//     return { type: constants.GET_MAINTENANCE_UPCOMING, payload: payloadData };
// }

const processAddEmi = (response) => {
    logger.log("VehicleActionCreator", "Incoming response from add new vehicle emi", response);
    return { type: null, payload: null };
}

const processCalenderDates = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_CALENDER_DATES, payload: payloadData };
}

const processFetchTruckBook = (response, defaultExpenseTypeFilter) => {
    if (response.response === null) {
        return { type: constants.GET_TRUCK_BOOK, payload: {} };
    } else {
        let payloadData = response.response;
        payloadData.defaultExpenseTypeFilterValue = defaultExpenseTypeFilter;
        if (response.status && response.status.code && response.status.code == 200) {
            var vehicleNumArray = getVehicleNumberValues(payloadData.vehicleNumber);
            payloadData.vehicleNumberPrefix = vehicleNumArray[0];
            payloadData.vehicleNumberSuffix = vehicleNumArray[1];
        }
        return { type: constants.GET_TRUCK_BOOK, payload: payloadData };
    }
}
const processFetchTruckBookV2 = (response, merge) => {
    if (response.response === null) {
        return { type: constants.GET_TRUCK_BOOK, payload: {} };
    } else {
        let payloadData = response.response;
        //payloadData.defaultExpenseTypeFilterValue = defaultExpenseTypeFilter;
        if (response.status && response.status.code && response.status.code == 200) {
            var vehicleNumArray = getVehicleNumberValues(payloadData.vehicleNumber);
            payloadData.vehicleNumberPrefix = vehicleNumArray[0];
            payloadData.vehicleNumberSuffix = vehicleNumArray[1];
        }
        payloadData.merge = merge
        return { type: constants.GET_TRUCK_BOOK, payload: payloadData };
    }
}



const processEmiSelectDate = (response) => {
    logger.log("VehicleActionCreator", response);
    let payloadData = response.response;
    return { type: constants.GET_EMI_SELECT_DATE, payload: payloadData };
}

const processDocumentConfig = (response) => {
    let payloadData = response && response.response && response.response.vehicle_document_reminder_config ? response.response.vehicle_document_reminder_config : {};
    return { type: constants.GET_DOCUMENT_CONFIG, payload: payloadData }
}

const processDeleteExpense = (response) => {
    logger.log("VehicleActionCreator", "----> INCOMING DELETE EXPENSE RESPONSE : ", response);
    return { type: null, payload: null };
}

const processDeletePhotoDetails = (response) => {
    logger.log("VehicleActionCreator", "----> INCOMING DELETE PHOTO RESPONSE : ", response);
    return { type: null, payload: null };
}

const processUpdateExpenseDetails = (response) => {
    logger.log("VehicleActionCreator", "----> INCOMING UPDATE EXPENSE TYPE RESPONSE : ", response);
    return { type: null, payload: null };
}

const processFetchExpenseDetails = (response) => {
    logger.log("VehicleActionCreator", "Single expense data", response);
    let payloadData = response.response;
    if (response.status && response.status.code && response.status.code == 200) {
        var vehicleNumArray = getVehicleNumberValues(payloadData.vehicleNumber);
        payloadData.vehicleNumberPrefix = vehicleNumArray[0];
        payloadData.vehicleNumberSuffix = vehicleNumArray[1];
    }
    return { type: constants.GET_SINGLE_EXPENSE, payload: payloadData }
}

const processAddExpenseType = (response) => {
    logger.log("VehicleActionCreator", "----> INCOMING ADD EXPENSE TYPE RESPONSE : " + JSON.stringify(response))
    return { type: null, payload: null };
}

const processDriverExpenses = (response) => {
    let payloadData = response.response;
    return { type: constants.DRIVER_EXPENSE_TYPE, payload: payloadData }
}

const processTripExpenses = (response, defaultTripBookFilterValue, merge) => {
    let payloadDataValue = response.response;
    payloadDataValue.singleVehicleMerge = merge
    let data = {
        payloadData: payloadDataValue,
        defaultTripBookFilter: defaultTripBookFilterValue
    }
    return { type: constants.TRIP_EXPENSES, payload: data }
}

const processTripPandL = (response, defaultDateFilterValue,empty) => {
    let payloadDataValue = response.response;
    let data = {
        payloadData: payloadDataValue,
        defaultDateFilter: defaultDateFilterValue
    }
    if(empty){
        return { type: null, payload: null }
    }
    return { type: constants.P_AND_L, payload: data }
}
const processVehicleMonthlyProfitLoss = (response) => {
    let payloadData = response.response;
    return { type: constants.VEHIClE_PROFIT_AND_LOSS_MONTHLY, payload: payloadData }
}
const processVehicleMonthlyProfitLossPDF = (response) => {
    let payloadData = response.response;
    return { type: constants.VEHIClE_PROFIT_AND_LOSS_MONTHLY_PDF, payload: payloadData }
}
const processVehicleTripPNLMonths = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_TRIP_PNL_MONTHS, payload: payloadData }
}
const processVehicleTripPNLMonthlyPDF = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_TRIP_PNL_MONTHLY_PDF, payload: payloadData }
}
const processVehicleDocumentPDF = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_VEHICLE_DOCUMENT_PDF, payload: payloadData }
}
const processSingleTruck = (response) => {
    let payloadData = response.response;
    if (response.status && response.status.code && response.status.code == 200) {
        var vehicleNumArray = getVehicleNumberValues(payloadData.vehicleNumber);
        payloadData.vehicleNumberPrefix = vehicleNumArray[0];
        payloadData.vehicleNumberSuffix = vehicleNumArray[1];
        payloadData.vehicleNumberArrayDweb = getVehicleNumberValuesDWeb(payloadData.vehicleNumber);
        if (payloadData && payloadData.driverId) {
            payloadData.driver = {
                name: payloadData.driverName ? payloadData.driverName : "",
                id: payloadData.driverId,
                contactNumber: payloadData.driverNumber ? payloadData.driverNumber : ""
            }
            payloadData.driverContactNumber = payloadData.driverNumber ? payloadData.driverNumber : ""
        }
    }
    return { type: constants.SINGLE_TRUCK_DATA, payload: payloadData }
}

const processUpdatedVehicle = (response) => {
    let payloadData = response.response;
    if (response.status && response.status.code && response.status.code == 200) {
        var vehicleNumArray = getVehicleNumberValues(payloadData.vehicleNumber);
        payloadData.vehicleNumberPrefix = vehicleNumArray[0];
        payloadData.vehicleNumberSuffix = vehicleNumArray[1];
        logger.log("VehicleActionCreator", "--> Vehicle Updation Success");
    }
    return { type: constants.UPDATE_VEHICLE, payload: payloadData };
}

const processVehicleExpenses = (response) => {
    return { type: constants.VEHICLE_EXPENSE_TYPE, payload: response.response };
}

export const processAddExpensePhoto = (photo) => {
    return { type: constants.ADD_EXPENSE_PHOTO_UPLOAD, payload: photo };
}

export const fetchSingleDriver = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/driver/" + id,
        data,
        success: (response) => processFetchDriverDetail(response, data && data.merge ? data.merge : false),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const fetchSingleShopAndTransaction = (id, data, onSuccess, onError) => {
    let query = ""
    if (data) {
        if (data.searchText) {
            query += `?search=${data.searchText}`
        }
        if (data.pageSize) {
            query += query ? `&&pageSize=${data.pageSize}` : `?pageSize=${data.pageSize}`
        }
        if (data.pageNo) {
            query += query ? `&&pageNo=${data.pageNo}` : `?pageNo=${data.pageNo}`
        }
    }
    return ({
        type: constants.API,
        payload: {
            method: "GET",
            url: `/khata/shop/${id}/transactions${query ? query : ""}`,
            data,
            success: (response) => processFetchShopDetails(response, data && data.merge ? data.merge : false),
            postProcessSuccess: onSuccess,
            postProcessError: onError,
        }
    });
}

const processFetchDriverDetail = (response, merge) => {
    let payloadData = response.response;
    payloadData.merge = merge
    return { type: constants.SINGLE_DRIVER_DETAILS, payload: payloadData };
}

const processFetchShopDetails = (response, merge) => {
    let payloadData = response.response;
    payloadData.merge = merge
    return { type: constants.GET_SINGLE_SHOP_DETAILS, payload: payloadData };
}


export const driverSettleAmount = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/driver_balance/settle",
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const driverAdditionType = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/driver/addition_types",
        success: (response) => processDriverAdditionType(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const driverDeductionType = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/driver/deduction_types",
        success: (response) => processDriverDeductionType(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const driverAddTranscationType = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/driver/transaction_type",
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const addReduceDriverTransaction = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/driver_transaction",
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const addShopTransaction = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/khata/shop/${data.id}/transaction`,
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const getShopTransaction = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/khata/shop/${data.id}/transaction/${data.transactionId}`,
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const fetchSingleDriverTransaction = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/driver_transaction/" + id,
        success: (response) => processSingleDriverTransaction(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const editSingleDriverTransaction = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: "/driver_transaction/" + id,
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const editShopTransaction = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: `/khata/shop/${id}/transaction/${data.id}`,
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const deleteSingleDriverTransaction = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: "/driver_transaction/" + id,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const deleteSingleShopTransaction = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: `/khata/shop/${data.shopId}/transaction/${data.id}`,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const deleteDriver = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: "/driver/" + id,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const editDriver = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: "/driver/" + id,
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const deleteVehicle = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: "/vehicles-v3/" + id,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const simTrackingRegister = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/simtrack/register-v2/vehicle",
        data,
        success: (response) => processSimTrackingResponse(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
});

export const getLocationForSimTracking = (tripId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/simtrack/location/trip/" + tripId,
        success: (response) => processSimTrackingGetLocationResponse(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
});

const processSimTrackingGetLocationResponse = (response) => {
    return { type: constants.GET_LOCATIONS_FOR_SIM_TRACKING, payload: response.response }
};

const processDriverNameList = (response) => {

    return { type: constants.GET_DRIVER_NAME_LIST, payload: response.response };
}

const processSingleDriverTransaction = (response) => {
    let payloadData = response.response;
    if (response.status && response.status.code && response.status.code == 200) {
        if (payloadData && payloadData.vehicleInfo) {
            var vehicleNumArray = getVehicleNumberValues(payloadData.vehicleInfo.vehicleNumber);
            payloadData.vehicleInfo.vehicleNumberPrefix = vehicleNumArray[0];
            payloadData.vehicleInfo.vehicleNumberSuffix = vehicleNumArray[1];
            logger.log("VehicleActionCreator", "--> Vehicle Updation Success");
        } else
            if (payloadData.tripInfo && payloadData.tripInfo.vehicle) {
                var vehicleNumArray = getVehicleNumberValues(payloadData.tripInfo.vehicle.vehicleNumber);
                payloadData.tripInfo.vehicle.vehicleNumberPrefix = vehicleNumArray[0];
                payloadData.tripInfo.vehicle.vehicleNumberSuffix = vehicleNumArray[1];
                logger.log("VehicleActionCreator", "--> Vehicle Updation Success");
            }
    }
    return { type: constants.GET_SINGLE_DRIVER_TRANSACTION, payload: payloadData }
}

const processDriverAdditionType = (response) => {
    return { type: constants.GET_DRIVER_ADDITION_TYPES, payload: response.response }
}

const processDriverDeductionType = (response) => {
    return { type: constants.GET_DRIVER_DEDUCTION_TYPES, payload: response.response }
}

const processSimTrackingResponse = (response) => {
    return { type: constants.GET_SIM_TRACKING_DETAILS, payload: response.response }
}

export const vehcileMonthlyPnlReportV2 = (vehicleId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/v2/vehicle/" + vehicleId + "/pnl/monthly-report/pdf",
        data,
        success: (response) => processVehcileMonthlyPnlReportV2(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
});

const processVehcileMonthlyPnlReportV2 = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_VEHICLE_MONTHLY_PNL_PDF, payload: payloadData }
}

export const vehcileMonthlyPnlReportPdf = (vehicleId, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/v2/vehicle/" + vehicleId + "/pnl/monthly-report/pdf/download",
        data,
        success: (response) => processVehcileMonthlyPnlReportPdf(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
});

const processVehcileMonthlyPnlReportPdf = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_VEHICLE_MONTHLY_PNL_PDF_LINK, payload: payloadData }
}

export const truckIncomeExcel = (filterData, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/excel/truck/income?monthYear=" + filterData,
        success: (response) => processTruckIncomeExcel(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
});

const processTruckIncomeExcel = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_TRUCK_INCOME_EXCEL, payload: payloadData }
}

export const fetchDriverOnlineTransaction = (transactionId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/transaction-history/driver/" + transactionId,
        success: (response) => processOnlineDriverTransaction(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
});

const processOnlineDriverTransaction = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_ONLINE_DRIVER_TRANSACTION, payload: payloadData }
}

export const getSingleDriverKhatPdf = (driverId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/driver/${driverId}/pdf/download`,
        success: (response) => processSingleDriverKhataPdf(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
})

const processSingleDriverKhataPdf = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_SINGLE_DRIVER_KHATA_PDF, payload: payloadData }
}

// ********************** Diesel Card Flow **********************
export const fetchFuelCardList = (requestData, onSuccess, onError) => {

    let query = ""

    if (requestData && requestData.pageSize) {
        query += `pageSize=${requestData.pageSize}`
    }
    if (requestData && requestData.pageNo) {
        query += `&pageNo=${requestData.pageNo}`
    }
    if (requestData && requestData.searchText) {
        query += `&searchText=${requestData.searchText}`
    }

    return ({
        type: constants.API,
        payload: {
            method: 'GET',
            url: `/v2/fuel-card/trucks?` + query,
            success: (response) => processDieselCardList(response, requestData && requestData.merge ? true : false),
            postProcessSuccess: onSuccess,
            postProcessError: onError
        }
    })
}

const processDieselCardList = (response, merge) => {
    let responsePayload = response.response

    if (responsePayload.hasOwnProperty('trucks')) {
        var trucks = responsePayload.trucks
        for (var i = 0; i < trucks.length; i++) {
            var vehicleNumArrayValue = getVehicleNumberValuesDWeb(trucks[i].vehicleNumber);
            trucks[i].vehicleNumArrayValue = vehicleNumArrayValue
        }
        responsePayload.trucks = trucks
    }
    return { type: constants.GET_DIESEL_CARD_LIST, payload: { dieselCardData: responsePayload, merge: merge } }
}

export const getDieselCardDriverList = (onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: 'GET',
        url: '/drivers/fuel-card',
        success: (response) => processDieselCardDriverList(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
})

const processDieselCardDriverList = (response) => {
    let payload = response.response
    return { type: constants.GET_FUEL_CARD_DRIVERS_LIST, payload: payload }
}

export const generateFuelCard = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: 'POST',
        url: '/fuel-card',
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
})

export const rechargeFuelCard = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: 'PUT',
        url: '/fuel-card/recharge',
        success: (response) => processUselessData(response),
        data,
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
})

export const getSingleDieselCard = (data, onSuccess, onError) => {

    var query = "";

    if (data) {
        if (data.vehicleId) {
            query += `vehicleId=${data.vehicleId}&`;
        }

        if (data.brokerId) {
            query += `brokerId=${data.brokerId}&`
        }

        if (data.pageSize) {
            query += `page_size=${data.pageSize}&`
        }

        if (data.pageNo) {
            query += `page_no=${data.pageNo}`
        }
    }

    return ({
        type: constants.API,
        payload: {
            method: 'GET',
            url: "/fuel-card/passbook?" + query,
            success: (response) => processSingleDieselCard(response, data),
            postProcessSuccess: onSuccess,
            postProcessError: onError
        }
    })
}

const processSingleDieselCard = (response, requestData) => {
    let payloadData = response.response;
    payloadData["vehicleNumArrayValue"] = getVehicleNumberValuesDWeb(payloadData.vehicleNumber);
    return { type: constants.GET_SINGLE_DIESEL_CARD, payload: { merge: requestData && ('merge' in requestData) ? requestData.merge : false, responseData: payloadData } }
}

export const updateDieselCardPin = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: 'PUT',
        url: "/fuel-card/pin",
        data,
        success: (response) => processUselessData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
})

export const getDieselCardTransactionDetails = (requestData, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: 'GET',
        url: `/fuel-card/transaction/details?event_type=${requestData.eventType}&id=${requestData.transactId}`,
        success: (response) => handleGetDieselCardTransactionDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
})

const handleGetDieselCardTransactionDetails = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_DIESEL_CARD_TRANSACTION_DETAILS, payload: payloadData }
}

export const getCashbackStepper = (requestData, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/fuel-card/cashback/stepper?monthYear=${requestData && requestData.monthYear ? requestData.monthYear : ""}`,
        success: (response) => handleGetCashbackStepper(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
})

const handleGetCashbackStepper = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_CASHBACK_STEPPER, payload: payloadData }
}

export const calculateCashBack = (fuelExpense, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: 'GET',
        url: `/fuel-card/cashback/${fuelExpense}`,
        success: (response) => handleCalculateCashback(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
})

const handleCalculateCashback = (response) => {
    let payloadData = response.response;
    return { type: constants.CALCULATE_CASHBACK, payload: payloadData }
}

const processUselessData = (response) => {
    logger.log("Vehicle action creator", response);
    return { type: null, payload: null }
}
